export default {
  0: '無断キャンセル',
  1: 'キャンセル',
  2: '未確定',
  3: 'テーブル未指定',
  4: '来店待ち',
  5: 'ご来店',
  6: 'お食事済み',
  7: 'お会計済み',
  8: 'お帰り',
  9: 'リセット済み',
  10: '一部来店',
  11: 'ブロック',
  12: '媒体確認中',
}

export const statusClassMap = {
  0: 'no-visit',
  1: '',
  2: 'table-unsettled',
  3: 'table-unspecified',
  4: 'visit-waiting',
  5: 'visiting',
  6: 'eaten',
  7: 'accounted',
  8: 'return',
  9: 'cleaned',
  10: 'partial-visiting',
  11: 'block',
  12: 'checking',
}

export const checkStatus = {
  isWithoutNotice: status => status === 0,
  isCanceled: status => status === 1,
  isUnsettled: status => status === 2,
  isTableNotSpecified: status => status === 3,
  isVisitWaiting: status => status === 4,
  isVisiting: status => status === 5,
  isEaten: status => status === 6,
  isAccounted: status => status === 7,
  isReturn: status => status === 8,
  isCleaned: status => status === 9,
  isPartialVisiting: status => status === 10,
  isBlock: status => status === 11,
  checking: status => status === 12,
}
